export default "__VITE_ASSET__NxzefCKy__"